import React from "react";

function DetailPortofolioArrows({ prevSlide, nextSlide }) {
  return (
    <div className="portofolio-arrows">
      <span className="portofolio-prev" onClick={prevSlide}>
        &#10094;
      </span>
      <span className="portofolio-next" onClick={nextSlide}>
        &#10095;
      </span>
    </div>
  );
}

export default DetailPortofolioArrows;
